import { useEffect, useState } from "react";
import {
  Input,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalBody,
  InputGroupAddon,
  Button,
  Row,
  Col,
  Card,
  CardBody,
  Label,
} from "reactstrap";
import { isNullOrEmpty } from "../../../../config/ENV";
import { BsFillEyeFill } from "react-icons/bs";
import {
  getContactNotes,
  getLocationContactNotes,
} from "../../../../services/AccountService";
import { showLocalDateTime } from "../../../../utilities/timeutility";
import Linkify from "react-linkify";
import { Colxx } from "../../../../components/common/CustomBootstrap";

const HiringCoordinatorContacts = (props) => {
 const [selectedHiringCoordinatorContact,setSelectedHiringManagerContact]=useState(props.selectedHiringCoordinatorContact);
  const {
    hiringCoordinatorContactsView,
  } = props;
   
  const [locationContact, setLocationContact] = useState();
  const [baseModalright, setBaseModalRight] = useState(false);
  const [contactsView, setContactsView] = useState(hiringCoordinatorContactsView);

  const [notesList, setNotesList] = useState([]);
  const [locationContactName, setLocationContactName] = useState("");
  let count = 0;


  useEffect(() => {
    if (locationContactName === "select Location Account") {
      setContactsView(false);
    }

    if (!isNullOrEmpty(props.selectedHiringCoordinatorContactId)) {
      setLocationContactName(props.selectedHiringCoordinatorContactId);
    } else {
      setLocationContactName("");
    }
    if (
      !isNullOrEmpty(selectedHiringCoordinatorContact) &&
      selectedHiringCoordinatorContact != null &&
      selectedHiringCoordinatorContact != undefined
    ) {
      setLocationContact(selectedHiringCoordinatorContact);
    } else {
      setLocationContact("");
    }
    setContactsView(props.hiringCoordinatorContactsView);
  }, [props.selectedHiringCoordinatorContactId]);

  function handleAccountContactChange(e) {
    setLocationContactName(e.target.value);
    props.parentCallback(e.target.value);
    for (var i = 0; i < props.locationContacts.length; i++) {
      if (props.locationContacts[i].id === e.target.value) {
        setLocationContact(props.locationContacts[i]);
        // setLocationView(true);

        return;
      }
    }
  }
 
  useEffect(() => {
     var selectedHiringCoordinatorContactId=props.selectedHiringCoordinatorContactId;

 if (!isNullOrEmpty(selectedHiringCoordinatorContactId)) {
      getAccountNotes(selectedHiringCoordinatorContactId);
    }
  }, [props.selectedHiringCoordinatorContactId]);

  const getAccountNotes = (selectedHiringCoordinatorContactId) => {    
    getContactNotes(selectedHiringCoordinatorContactId).then((response) => {
      if (response.status === 200) {
        if(response.data!=null){
          let notesData=response.data;
          if(notesData.contactNotes!=null){
            setNotesList(notesData.contactNotes);
          }          
        }           
      }
    });
  };
  const ShowHiringType = (hiringType) =>{
    if (!isNullOrEmpty(hiringType)){
        if(hiringType.value == "Hiring Manager"){
         return " - HM"
        }
        else if(hiringType.value == "Hiring Coordinator"){
          return " - HC"
        }
    }
  
    }

  const showName = (name) => {
    if (!isNullOrEmpty(name)) {
      if (name.includes("null")) {
        let Arr = [];
        Arr = name.split(" ");
        delete Arr[1];
        return Arr[0];
      }
    }

    return name;
  };

  const showNotesList = (notes) => {
    return (
      <>
        {notes.length > 0 &&
          notes.map((note, index) => {
            return (
              <div key={note.id}>
                <div className="">
                  <span>
                    <div>
                      <div className="row ">
                        <Col className="col-9 p-0">
                          <Col>
                            <span className=" mr-2 font-semibold ">
                              {showName(note.commentedByName)}
                            </span>
                            <div>{showLocalDateTime(note.createdOn)}</div>
                            <div>
                              <Linkify>{note.notes}</Linkify>
                            </div>
                            <Row>
                              <Col> </Col>
                            </Row>
                          </Col>
                        </Col>

                        {/* <Col className="text-right">
                          {showDeleteButton(note)}
                        </Col> */}
                      </div>
                    </div>
                  </span>
                </div>
                {notes.length > 1 && index != notes.length - 1 && (
                  <>
                    <hr />
                  </>
                )}
              </div>
            );
          })}
      </>
    );
  };

  return (
    <>
      <Input
        type="select"
        value={locationContactName}
        onChange={(e) => handleAccountContactChange(e)}
      >
        <option value="" className="t-rounded-lg">
          Select Account Contact
        </option>

        {props.locationContacts.map((locationContact,index) => {
          return (   
            <optgroup  label={locationContact.locationName} key={index}>
              
            

{
  locationContact.contacts.map((contact)=>{

    return(<option key={contact.id} value={contact.id}>
      {contact.firstName+" "}
     {!isNullOrEmpty(contact.lastName) && contact.lastName} 
    {ShowHiringType(contact.hiringType)}
      </option>)
    
  })
}       
       </optgroup>         
            
          );
        })}
      </Input>

      {contactsView === true ? (
        <>
        {!isNullOrEmpty(locationContactName) &&
        
        locationContactName !== "Select Location Contact"  && 
        <InputGroupAddon addonType="append" title="View Hiring Coordinator Details">
            <Button
              // className="t-input-group-right-radius"
              color="dark"
              outline
              onClick={() => setBaseModalRight(true)}
            >
              <BsFillEyeFill className="danger" />
            </Button>
          </InputGroupAddon>}
          {" "}
         
        </>
      ) : (
        <></>
      )}


      <Modal
        scrollable={true}
        isOpen={baseModalright}
        toggle={() => setBaseModalRight(!baseModalright)}
        wrapClassName="modal-right"
        className="skill-model-width"
      >
        <>
          { (props.selectedHiringCoordinatorContact!=null) ? (
            <>
              <ModalHeader className="benefitmodal_header">
                {" "}
                <h2>
                  {" "}
                  <strong> {props.selectedHiringCoordinatorContact.firstName +" "+props.selectedHiringCoordinatorContact.lastName} </strong>
                </h2>
              </ModalHeader>
              <ModalBody>
                <Row className="">
                  <Colxx sm={2}>
                    <Label> Email </Label>
                  </Colxx>
                  :
                  <Colxx sm={8}>
                    <b>{props.selectedHiringCoordinatorContact.email}</b>
                  </Colxx>
                </Row>
                <Row className="">
                  <Colxx sm={2}>
                    <Label> Mobil Number </Label>
                  </Colxx>
                  :
                  <Colxx sm={8}>
                    <b> {props.selectedHiringCoordinatorContact.mobileNumber}</b>
                  </Colxx>
                </Row>
                <Row className="">
                  <Colxx sm={2}>
                    <Label> Office Number </Label>
                  </Colxx>
                  :
                  <Colxx sm={8}>
                    <b>{props.selectedHiringCoordinatorContact.officeNumber}</b>
                  </Colxx>
                </Row>
                <Row className="">
                  <Colxx sm={2}>
                    <Label> Linkedin Url </Label>
                  </Colxx>
                  :
                  <Colxx sm={8}>
                    <b>{props.selectedHiringCoordinatorContact.linkedInUrl}</b>
                  </Colxx>
                </Row>
                <Row className="">
                  <Colxx sm={2}>
                    <Label>Facebook Url </Label>
                  </Colxx>
                  :
                  <Colxx sm={8}>
                    <b>{props.selectedHiringCoordinatorContact.facebookUrl}</b>
                  </Colxx>
                </Row>
                <Row className="">
                  <Colxx sm={2}>
                    <Label> Twitter Url </Label>
                  </Colxx>
                  :
                  <Colxx sm={8}>
                    <b>{props.selectedHiringCoordinatorContact.twitterUrl}</b>
                  </Colxx>
                </Row>
                <Row className="">
                  <Colxx sm={2}>
                    <Label> Hiring Type </Label>
                  </Colxx>
                  :
                  <Colxx sm={8}>
                    <b>{
                    !isNullOrEmpty(props.selectedHiringCoordinatorContact.hiringType)&&
                    props.selectedHiringCoordinatorContact.hiringType.value}</b>
                  </Colxx>
                </Row>

                {!isNullOrEmpty(notesList) ? (
                  <>
                    <hr />
                    <Row className="">
                      <Colxx>
                        <strong>Notes:</strong>
                        <CardBody className="px-0">
                          {!isNullOrEmpty(notesList) && (
                            <> {showNotesList(notesList)}</>
                          )}
                        </CardBody>
                      </Colxx>
                    </Row>
                  </>
                ) : (
                  <></>
                )}
              </ModalBody>
            </>
         ) : (
            <></>
          )} 

          {/* {locationContact.email} */}
        </>

        <ModalFooter>
          <Button
            color="secondary"
            size="sm"
            onClick={() => setBaseModalRight(false)}
          >
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};
export default HiringCoordinatorContacts;